import { hookstate } from "@hookstate/core";

export const UserStocks = hookstate(null);
